import styles from '../../bmweDataTable.module.css';
import { tableStrings } from '../../i18n/de-de';

interface LoaderRowProps {
  columnsCount: number;
  virtualStart: number;
  virtualIndex: number;
  ariaRowIndex: number;
  measure: (el: Element | null) => void;
}

export function LoaderRow({
  columnsCount,
  virtualStart,
  virtualIndex,
  ariaRowIndex,
  measure,
}: LoaderRowProps) {
  return (
    <tr
      key="loader-row"
      data-index={virtualIndex}
      ref={(node) => measure(node)}
      role="row"
      aria-rowindex={ariaRowIndex}
      className={styles.bmweDataTableRow}
      style={{ '--rowTranslateY': `${virtualStart}px` } as React.CSSProperties}
      aria-busy="true"
    >
      <td
        role="gridcell"
        tabIndex={-1}
        className={`${styles.bmweDataTableCell} ${styles.tableCell}`}
        colSpan={columnsCount}
      >
        <div className={styles.loaderContent}>
          <span className="pi pi-refresh pi-spin" aria-hidden="true" />
          <span>{tableStrings.messages.loadingMore}</span>
        </div>
      </td>
    </tr>
  );
}
